const locale = {
    'CodePanel.loading': 'Loading code editor...',
    'MiniCode.example': 'Example',
    'MiniCode.scanQrcode': 'Please scan the QR code to view the example',
    'DevicePreview.desktop': 'Desktop',
    'DevicePreview.mobile': 'Mobile',
    'DevicePreview.iphoneProMax': 'iPhone Pro Max',
    'DevicePreview.iphonePro': 'iPhone Pro',
    'DevicePreview.iphoneSE': 'iPhone SE'
};

export default locale;
